import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@feathr/components';
import { getIconForAction } from '@feathr/hooks';

import { useMetaOAuth } from './MetaConnectButton.hooks';

function MetaConnectButton(): JSX.Element {
  const { t } = useTranslation();
  const { initiateOAuth, isLoading } = useMetaOAuth();

  return (
    <Button
      isLoading={isLoading}
      name={'connect-meta-button'}
      onClick={initiateOAuth}
      prefix={getIconForAction('meta')}
      type={'primary'}
    >
      {t('Connect Meta Business Manager')}
    </Button>
  );
}

export default MetaConnectButton;
